import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Badge, FlexBox, Icon, IconButton, Text, Timestamp, Tooltip, } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { UnbanIpModal, } from 'components/shared/unbanIpModal/unbanIpModal';
import rowStyles from '../bansRow.module.scss';
const DELAY_FETCH = 1000;
// Table column components
// -----------------------
const renderIpAddress = ({ ip_address, }) => (_jsx(FlexBox, Object.assign({ alignItems: "center" }, { children: _jsx(Text.Paragraph, Object.assign({ className: rowStyles.userInfo }, { children: ip_address })) })));
const renderStatus = ({ bans }) => {
    var _a;
    return ((_a = bans[0]) === null || _a === void 0 ? void 0 : _a.is_ip_address_banned) ? (_jsx(Badge, Object.assign({ size: "small", variant: "error" }, { children: "Active" }))) : (_jsx(Badge, Object.assign({ size: "small", variant: "secondary" }, { children: "Inactive" })));
};
const renderNumberOfUsers = ({ bans }) => bans.filter((ban, index, self) => self.findIndex((b) => b.end_user.id === ban.end_user.id) === index).length;
const renderLastBan = ({ bans }) => {
    var _a, _b;
    return (_jsxs("div", Object.assign({ className: rowStyles.lastBanInfo }, { children: [((_a = bans[0]) === null || _a === void 0 ? void 0 : _a.banned_at) && (_jsx("div", Object.assign({ className: rowStyles.lastBanInfoDate }, { children: _jsx(Text.Paragraph, { children: _jsx(Timestamp, { relative: true, time: bans[0].banned_at }) }) }))), ((_b = bans[0]) === null || _b === void 0 ? void 0 : _b.banning_agent) && (_jsxs("div", Object.assign({ hidden: true, className: rowStyles.lastBanInfoAgent }, { children: ["by ", bans[0].banning_agent.name] })))] })));
};
const renderUnbanButtonWithRefreshItems = (refreshItems) => function RenderUnbanButton({ bans, ip_address, }) {
    var _a;
    const [isUnbanModalOpen, setIsUnbanModalOpen] = useState(false);
    return (((_a = bans[0]) === null || _a === void 0 ? void 0 : _a.is_ip_address_banned) && (_jsxs(_Fragment, { children: [_jsx(Tooltip, Object.assign({ content: "Unban", dark: true }, { children: _jsx(IconButton, { variant: "tertiary", icon: "undo", onClick: (e) => {
                        e.stopPropagation();
                        setIsUnbanModalOpen(true);
                    } }) })), _jsx(UnbanIpModal, { ipAddress: ip_address, isOpen: isUnbanModalOpen, onClose: (event) => {
                    setIsUnbanModalOpen(false);
                    if (!event.canceled && event.response) {
                        setTimeout(() => {
                            refreshItems();
                        }, DELAY_FETCH);
                    }
                } })] })));
};
// Sub-table column components
// ----------------------------
const renderChannelIcon = (ban) => (_jsx(Icon, { name: "chat", style: { verticalAlign: 'middle' } }));
const renderBannedUser = ({ end_user }) => (_jsx(Link, Object.assign({ to: `/contacts/user/${end_user.id}` }, { children: end_user.name })));
const renderBannedAt = ({ banned_at }) => (_jsx(Timestamp, { relative: true, time: banned_at }));
const renderConversation = ({ csid }) => (csid && _jsxs(Link, Object.assign({ to: `/conversation/${csid}` }, { children: ["#", csid] }))) || (_jsx(Text.Paragraph, Object.assign({ as: "span", subdued: true }, { children: "n/a" })));
const renderBannedBy = ({ banning_agent }) => (_jsx(Link, Object.assign({ to: `/contacts/user/${banning_agent.id}` }, { children: banning_agent.name })));
// Columns
// -------
export const tableColumns = (refreshItems) => [
    {
        label: 'IP Address',
        selector: renderIpAddress,
    },
    {
        label: 'Status',
        style: { width: '30%' },
        selector: renderStatus,
    },
    { label: 'Users', style: { width: 160 }, selector: renderNumberOfUsers },
    { label: 'Last ban', style: { width: '25%' }, selector: renderLastBan },
    {
        style: { width: 1 },
        selector: renderUnbanButtonWithRefreshItems(refreshItems),
    },
];
export const subTableColumns = [
    { style: { width: 1 }, selector: renderChannelIcon },
    { label: 'Banned user', style: { width: '20%' }, selector: renderBannedUser },
    { label: 'Banned at', style: { width: '18%' }, selector: renderBannedAt },
    { label: 'Conversation', selector: renderConversation },
    { label: 'Banned by', selector: renderBannedBy },
];
